import axios from 'axios';
import { factory } from './factory';

const createApi = () => {
  const methods = factory(axios);

  return {
    methods,
  };
};

export const api = createApi();
